import React from "react";
import { Link } from "gatsby";

// CSS
import "./Home.css";

const Home = ({ title, description, bgImageClass, videoPath }) => {
  return (
    <section
      id="home"
      className="home-section staff-augmentation w-100 d-flex align-items-center"
    >
      <div className={`bg-home h-100 ${bgImageClass && bgImageClass}`} />
      <div className="container">
        <div className="small-container">
          <div className="intro col-lg-8 col-md-10">
            <h1 className="text-white fs-1 m-0 lh-normal bold fst-normal">
              {title}
            </h1>

            <p className="fs-4 text-white py-4 mb-4">{description}</p>
            <Link
              className="btn-solid-lg rounded fw-bold px-5 py-4 fs-5"
              // to="https://meetings.hubspot.com/hanzala"
              to="/contact"
              role="button"
              target="_blank"
            >
              Book a call
            </Link>
          </div>
        </div>
      </div>

      {videoPath && (
        <video
          poster={videoPath.poster}
          className="background-video"
          playsInline
          autoPlay
          muted
        >
          <source src={videoPath.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </section>
  );
};

export default Home;
